// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__39Fwl","tooltipText":"Tooltip_tooltipText__Fmwmc"};